export default __webpack_public_path__ + "ccb239e565b5fc2ed3a17e50d3091364.png";